//AnimatedCommand.js
import useTypewriter from '../hooks/useTypewriter.js';

export default function AnimatedCommand({ text, delay = 0 }) {
  const typedText = useTypewriter(text, 11, delay);
  return <>{typedText}</>;
}
